export const CUSTOMER_RESTRICTION = {
  PREPAYMENT: 'prepayment',
  BLOCKED: 'blocked',
  BANNED: 'banned'
}

export const CL_CUSTOMER_STATUS = ['prospect', 'repeat', 'acquired']

// Commerce Layer tag names grouped by the flag they represent. A customer can
// carry any one of the names in a group.
export const CUSTOMER_FLAG = {
  INFLUENCER: 'influencer',
  EMPLOYEE: 'employee',
  INVESTOR: 'investor'
}

export const CUSTOMER_FLAG_TAGS = {
  [CUSTOMER_FLAG.INFLUENCER]: ['influencer'],
  [CUSTOMER_FLAG.EMPLOYEE]: [
    'employee-ch-low',
    'employee-ch-mid',
    'employee-ch-full',
    'employee-de-low',
    'employee-de-mid',
    'employee-de-full',
    'employee-at-low',
    'employee-at-mid',
    'employee-at-full'
  ],
  [CUSTOMER_FLAG.INVESTOR]: ['investors', 'investors-eu', 'investors-ch']
}

export const GUEST_USER_EMAILS = [
  'vcp+guestde@shopviu.com',
  'vcp+guestat@shopviu.com',
  'vcp+guestch@shopviu.com'
]

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
